import React from 'react';
import { Section } from './ui/Section';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    title: 'BONO 1 — EL ARRANQUE RÁPIDO',
    desc: 'La hoja de ruta de los primeros 7 días para quien empieza desde cero o quiere resetear su negocio completamente. Qué hacer el día 1, qué instalar primero y cómo conseguir el primer cliente en menos de una semana.',
    value: '29€'
  }, {
    num: '02',
    title: 'BONO 2 — 25 MENSAJES ANTI-VISTO',
    desc: 'Los 25 mensajes de prospección, seguimiento y cierre que realmente generan respuesta. Adaptados a LinkedIn, Instagram, email y WhatsApp. Sin parecer desesperado. Sin copiar y pegar lo que hace todo el mundo.',
    value: '19€'
  }, {
    num: '03',
    title: 'BONO 3 — CHECKLIST DE PRESUPUESTOS',
    desc: 'La lista de verificación de 27 puntos que revisas antes de enviar cualquier propuesta. Para no olvidar ninguna cláusula, no regalar trabajo y no mandar un presupuesto del que luego te arrepientes.',
    value: '19€'
  }];
  return <Section data-id="element-42">
      <div className="text-center mb-12" data-id="element-43">
        <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-44">
          🎁 3 BONOS ESTRATÉGICOS
        </h2>
        <span className="inline-block bg-brand-accent text-white font-bold px-4 py-1 rounded-full text-sm tracking-wider" data-id="element-45">
          SIEMPRE INCLUIDOS
        </span>
      </div>

      <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-46">
        {bonuses.map((bonus, i) => <div key={i} className="bg-brand-card border border-neutral-800 rounded-2xl p-8 relative overflow-hidden group hover:border-brand-accent/30 transition-colors" data-id="element-47">
            <div className="absolute -right-4 -top-4 text-8xl font-black text-neutral-900 opacity-50 group-hover:text-neutral-800 transition-colors" data-id="element-48">
              {bonus.num}
            </div>
            <div className="relative z-10" data-id="element-49">
              <div className="text-2xl mb-4" data-id="element-50">🎁</div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-51">
                {bonus.title}
              </h3>
              <p className="text-neutral-400 leading-relaxed mb-6" data-id="element-52">
                {bonus.desc}
              </p>
              <div className="flex items-center gap-3 mt-auto" data-id="element-53">
                <span className="text-neutral-500 line-through text-lg" data-id="element-54">
                  {bonus.value}
                </span>
                <span className="text-brand-accent font-bold text-xl" data-id="element-55">
                  GRATIS
                </span>
              </div>
            </div>
          </div>)}
      </div>

      <div className="bg-neutral-900 border border-neutral-800 rounded-2xl p-6 max-w-md mx-auto text-center flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8" data-id="element-56">
        <div data-id="element-57">
          <div className="text-neutral-400 text-sm mb-1" data-id="element-58">Valor total bonos</div>
          <div className="text-2xl font-bold text-neutral-500 line-through" data-id="element-59">
            67€
          </div>
        </div>
        <div className="hidden md:block text-neutral-600 text-3xl" data-id="element-60">→</div>
        <div data-id="element-61">
          <div className="text-neutral-400 text-sm mb-1" data-id="element-62">Con tu MegaPack</div>
          <div className="text-3xl font-bold text-brand-accent" data-id="element-63">GRATIS</div>
        </div>
      </div>
    </Section>;
}